import { ChevronRight } from "lucide-react";
import { ItemsTable } from "@/components/items/ItemsTable";

export function ItemsPage() {
  return (
    <>
      <div className="topbar">
        <div className="topbar__crumbs">
          <span>Engineering</span>
          <ChevronRight size={14} />
          <strong>Items</strong>
        </div>
      </div>
      <div className="page">
        <div className="page-header">
          <div>
            <h1 className="page-header__title">Items</h1>
            <p className="page-header__sub">Browse and manage items.</p>
          </div>
        </div>
        <ItemsTable />
      </div>
    </>
  );
}
